import { Chevron } from './components/icons';
import styles from './ParentLinkHeader.module.css';

export interface ParentLinkHeaderProps {
  breadcrumb: {
    name: string;
    url: string;
  };
  displayTitle?: string;
  title?: string;
}

export const ParentLinkHeader = ({
  breadcrumb,
  displayTitle,
  title
}: ParentLinkHeaderProps): JSX.Element => {
  const renderedTitle = displayTitle || title;

  const renderParentLinkHeaderContent = () => {
    return (
      <div className={styles.cardHeaderContentContainer}>
				<div
          className={`${styles.cardHeaderTextWrapper} ogm-card-header__title`}>

					<h1 className={styles.cardTitle}>{renderedTitle}</h1>
				</div>
			</div>);

  };

  return (
    <div className={styles.cardHeaderWrapper} data-testid="card-header">
			<div className={styles.cardHeaderInnerWrapper}>
				{!!breadcrumb &&
        <div className={styles.cardEventLinkWrapper}>
						<span className={styles.breadcrumbIcon}>{<Chevron />}</span>
						<a
            className={`${styles.cardEventLink} ogm-card-header__breadcrumb`}
            href={breadcrumb.url}
            title={breadcrumb.name}>

							{breadcrumb.name}
						</a>
					</div>
        }
				<div className={styles.cardBodyWrapper} id="card-header">
					{renderParentLinkHeaderContent()}
				</div>
			</div>
		</div>);

};